import React, { useEffect, useRef, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useScreenshot } from 'use-react-screenshot'
import html2canvas from 'html2canvas';
import { Accordion, AccordionTab } from "primereact/accordion";
import { useFormik } from 'formik';
import { Toast } from 'primereact/toast';
import { Button } from "primereact/button";
import { useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import { PMTemplate } from "../../../services/Template/pm-template";
import { Api } from "../../../services/api";
import { FaCopy } from "react-icons/fa";


const VIEW_JOB_AUTOPSY = ({ projectId, archiveId }) => {



  const { editId } = useParams();

  const [isLoading, setIsLoading] = useState(true);

  const [projectData, setProjectData] = useState([]);
  const [monthlyClientRating, setMonthlyClientRating] = useState([]);
  const [Section9Array, setSection9Array] = useState([{ name: '', }]);
  const [Section10Array, setSection10Array] = useState([{ name: '', }]);
  const [Section13Array, setSection13Array] = useState([{ name: '', }]);
  const [Section14Array, setSection14Array] = useState([{ name: '', }]);
  const [Section3Array, setSection3Array] = useState([{ name: '', }, { name: '', }, { name: '', }, { name: '', }, { name: '', }, { name: '', }, { name: '', }, { name: '', }, { name: '', }, { name: '', },]);

  const toast = useRef(null);

  const formik = useFormik({
    initialValues: PMTemplate.getFormName(),

  });

  useEffect(() => {

    getTemplateDetails(archiveId);

    return () => {
      // Cleanup tasks before the component is unmounted
    };
  }, []);

  const getTemplateDetails = (id, type) => {


    var url = Api.API_BASE_URL + 'all-template/get-archive-job-autopsy/' + archiveId + '/' + projectId;

    fetch(url, {
      method: "GET",

    })
      .then((response) => response.json())
      .then((response) => {
        // setIsLoading(false);

        if (response.error != '') {
          formik.setFieldValue('PmTempleteId', 0);
          formik.setFieldValue('projectId', id);
          formik.setFieldValue('ProjectName', response.EstimatorProjectName);

        } else {
          formik.setFieldValue('PmTempleteId', response.pmTemplateId);
          PMTemplate.section_1_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_1[element]);
          });
          PMTemplate.section_2_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_2[element]);
          });
          PMTemplate.section_3_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_3[element]);
          });
          PMTemplate.section_4_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_4[element]);
          });
          PMTemplate.section_5_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_5[element]);
          });
          if (response.pm_section_6.length != 0) {
            formik.setFieldValue(`section_6`, response.pm_section_6);
          }


          if (response.pm_section_3_new.length != 0) {
            formik.setFieldValue(`section_3`, response.pm_section_3_new);
            setSection3Array(response.pm_section_3_new);
          }




          // setMonthlyClientRating(response.pm_section_6);

          PMTemplate.section_7_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_7[element]);
          });
          PMTemplate.section_8_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_8[element]);
          });



          formik.setFieldValue(`section_9`, response.pm_section_9);
          setSection9Array(response.pm_section_9);
          formik.setFieldValue(`section_10`, response.pm_section_10);
          setSection10Array(response.pm_section_10);
          PMTemplate.section_11_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_11[element]);
          });
          PMTemplate.section_12_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_12[element]);
          });



          formik.setFieldValue(`section_13`, response.pm_section_13);
          setSection13Array(response.pm_section_13);
          formik.setFieldValue(`section_14`, response.pm_section_14);
          setSection14Array(response.pm_section_14);
          PMTemplate.section_15_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_15[element]);
          });
          PMTemplate.section_16_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_16[element]);
          });
          PMTemplate.section_17_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_17[element]);
          });
          PMTemplate.section_18_List().forEach(element => {
            formik.setFieldValue(element, response.pm_section_18[element]);
          });
        }

        setIsLoading(false);

      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error:", error);
      });
  }


  const renderTextArea = (fieldName, placeholder, formData = '', maxLine = 2,) => (
    <textarea
      placeholder={placeholder}
      name={fieldName}
      id={fieldName}
      rows={maxLine}
      disabled={true}
      value={formik.values[fieldName]}
      onChange={(e) => {

        formik.setFieldValue(fieldName, e.target.value)
      }}
      style={{ width: '100%', boxSizing: 'border-box', border: 'none', outline: 'none', fontSize: '16px', color: '#495057', }}
    >{formData}</textarea>
  );

  const renderInputArea = (fieldName, placeholder, type = 'text', fromData = '') => (
    <input
      type={type}
      placeholder={placeholder}
      name={fieldName}
      id={fieldName}
      disabled={true}
      value={fromData != '' ? fromData : formik.values[fieldName]}
      onChange={(e) => {
        formik.setFieldValue(fieldName, e.target.value);

        if (fieldName === 'sitePrep_P_B_C_Date') {

          formik.setFieldValue('scheduleConstructionStartDate', e.target.value);
        }
        if (fieldName === 'turnOver_C_F_C_Date') {
          formik.setFieldValue('scheduleProjectCompletion', e.target.value);
        }
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault(); // Prevent form submission on Enter key press
        }
      }}
      style={{
        width: '100%',
        height: '40px',
        boxSizing: 'border-box',
        border: 'none',
        fontSize: '16px',
        textAlign: 'center',
        marginTop: '0px',
      }}
    />
  );

  //! -----------------------
  const headerStyle = {
    background: "#FEC025",
    border: "1px solid #E9ECEF",
    textAlign: "center",
    fontSize: "18px",
  };

  const cellStyle = {
    border: "1px solid #E9ECEF",
    borderLeft: "2px solid #E9ECEF",

  };

  //! -----------------------


  return (
    <>


      <Toast ref={toast} />
      {isLoading ? (
        <div className="loading-spinner">
          Loading...
          <div className="spinner"></div>
        </div>
      ) : (


        <form onSubmit={formik.handleSubmit} className="pm-template-form">
          {/* <div className="flex d-flex justify-content-end top-button submitbutton ">
                    <Button className="m-2 mx-4 p-2 px-3 " severity="Secondary" type="button" title="Copy Client Weekly Update">
                        <strong className="mr-2">Copy weekly update</strong>
                        <FaCopy />
                    </Button>
                    <Button className="m-2 mx-4 p-2 px-4 d-flex align-items-center" severity="success" type="submit">
                        <strong className="mr-2">Save</strong>
                        <i className="pi pi-save"></i>
                    </Button>
                </div> */}


          <Toast ref={toast} />
          <div className="cardd" style={{ border: 'none', }}>
            <Accordion multiple activeIndex={[0]} >

              {/* Section 15 */}
              <AccordionTab header="JOB AUTOPSY" className="mt-2">
                <div className="table-container" style={{ overflowX: "auto" }}>
                  <table style={{ borderCollapse: "collapse", }}>
                    <thead>
                      <tr>
                        <th style={{ ...headerStyle, width: "400px" }}>

                        </th>
                        <th style={{ ...headerStyle, minWidth: "auto" }}>
                          JOB AUTOPSY
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={cellStyle}>Address:</td>
                        <td style={cellStyle}>{renderTextArea(`address`, '')}</td>
                      </tr>
                      <tr>
                        <td style={cellStyle}>Date of Meeting</td>
                        <td style={cellStyle}>{renderInputArea(`dateOfMeeting`, '', 'date')}</td>
                      </tr>
                      <tr>
                        <td style={cellStyle}>Who is present for Autopsy</td>
                        <td style={cellStyle}>{renderTextArea(`whoIsPresentForAutopsy`, '')}</td>
                      </tr>
                      <tr>
                        <td style={cellStyle}>Project Manager</td>
                        <td style={cellStyle}>{renderTextArea(`projectManager`, '')}</td>
                      </tr>

                      <tr>
                        <td style={cellStyle}>Interior Designer</td>
                        <td style={cellStyle}>{renderTextArea(`interiorDesigner`, '')}</td>
                      </tr>
                      <tr>
                        <td style={cellStyle}>Foreman</td>
                        <td style={cellStyle}>{renderTextArea(`foreman`, '')}</td>
                      </tr>
                      <tr>
                        <td style={cellStyle}>Project Summary:</td>
                        <td style={cellStyle}>{renderTextArea(`projectSummary_15`, '')}</td>
                      </tr>


                    </tbody>
                  </table>
                </div>
              </AccordionTab>

            </Accordion>
          </div>
        </form>

      )}

    </>
  );
};

export default VIEW_JOB_AUTOPSY;
